module.exports = __webpack_public_path__ + "img/17a002-04.0144d678.png";